import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  ButtonProps,
  Typography,
  Grid,
  GridProps,
} from '@mui/material';
import { FC, ReactNode } from 'react';

export type ConfirmDialogProps = {
  open: boolean;
  unCloseable?: boolean;
  handleClose: (result: boolean, data?: string) => void;
  title: string;
  description?: string;
  extra?: ReactNode;
  okText?: string;
  okProps?: ButtonProps;
  cancelText?: string;
  cancelProps?: ButtonProps;
  actionProps?: GridProps;
};

const ConfirmDialog: FC<ConfirmDialogProps> = ({
  open,
  handleClose,
  title,
  unCloseable = false,
  description,
  extra,
  okText = 'Xác nhận',
  okProps,
  cancelText,
  cancelProps,
  actionProps,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => !unCloseable && handleClose(false)}
      aria-labelledby='confirm-dialog-title'
      aria-describedby='confirm-dialog-description'
    >
      <DialogTitle id='confirm-dialog-title'>{title}</DialogTitle>
      {description && (
        <DialogContent>
          <DialogContentText id='confirm-dialog-description'>
            {description}
          </DialogContentText>
        </DialogContent>
      )}
      {extra && <DialogContent>{extra}</DialogContent>}
      <DialogActions>
        <Grid container spacing={1.5} {...actionProps}>
          {cancelText && (
            <Grid item xs={6}>
              <Button
                fullWidth
                variant='contained'
                color='inherit'
                size='large'
                onClick={() => handleClose(false)}
                {...cancelProps}
              >
                <Typography noWrap variant='subtitle2'>
                  {cancelText}
                </Typography>
              </Button>
            </Grid>
          )}
          <Grid item xs={cancelText ? 6 : 12}>
            <Button
              fullWidth
              variant='contained'
              size='large'
              onClick={() => handleClose(true)}
              {...okProps}
            >
              <Typography noWrap variant='subtitle2'>
                {okText}
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
